module.exports = __webpack_public_path__ + "static/mh-88087371dc19cd4994704077ad7a47d6.png";